import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';

import HttpService from '@/plugins/http-service';
import EventBus from '@/plugins/event-bus';
import IRootState from '@/store/types/IRootState';

import IContactFormData from './types/IContactFormData';
import IContactState from './types/IContactState';
import IContactMeta from './types/IContactMeta';
import IContactHeader from './types/IContactHeader';
import ITeamMember from './types/ITeamMember';

const actions: ActionTree<IContactState, IRootState> = {
  async load(context) {
    try {
      const { data: {
        meta,
        header,
        team,
      } }: AxiosResponse<{
        meta: IContactMeta,
        header: IContactHeader,
        team: ITeamMember[],
      }> = await HttpService.get(`/page/contact.json`);

      context.commit('setMeta', meta);
      context.commit('setHeader', header);
      context.commit('setTeam', team);

      return { meta, header, team };
    } catch (error) {
      return Promise.reject(error);
    }
  },

  submit(context, contactData: IContactFormData) {
    EventBus.$emit('progress-delay', 3);
    EventBus.$emit('progress-start');

    return HttpService.post('/form/submit', contactData, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response: any) => {
      return response.json();
    }).then((response: any) => {
      EventBus.$emit('progress-stop');
      EventBus.$emit('clear-contact-form');
    })
    .catch(() => {
      EventBus.$emit('progress-stop');
      EventBus.$emit('clear-contact-form');
    });
  },
};

export default actions;
